import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';

const getBackground = (props) => {
  switch (props.$heroOverlayType) {
    case 'gradient':
      return `linear-gradient(45deg, ${props.$bgColorStart}, ${props.$bgColorMid}, ${props.$bgColorEnd})`;
    case 'angled':
      return `
      linear-gradient(
        90deg,
        ${props.$bgColor} 50%,
        transparent 75%
      );
        `;
    case 'diamond':
      return ``;
    case 'solid':
      return `${props.$bgColor}`;
    default:
      return `${props.$bgColor}`;
  }
};

const StyledOverlay = styled.section`
  ${(props) => {
    if (props.$heroOverlayType === 'diamond') {
      return `
        position: absolute;
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
        background: ${props.$bgColor};
        clip-path: polygon(50% 0%, 100% 50%, 50% 100%, 0% 50%);
        transform: scale(1.75) translateX(-30vw);
      `;
    }
    if (props.$heroOverlayType === 'angled') {
      return `
        background: ${getBackground(props)};

        // Media query for smaller screens
        @media (max-width: 768px) {
          background: linear-gradient(
            180deg,
            ${props.$bgColor} 50%,
            transparent 75%
          );
        }
      `;
    }
    return `
        background: ${getBackground(props)};
      `;
  }}
`;

const Overlay = ({
  heroOverlayType,
  heroOverlayAngleDesktop,
  heroOverlayAngleMobile,
  heroOverlayWidth,
  heroOverlayHeight,
  hasHover,
  bgColor,
  bgColorHover,
  bgColorStart,
  bgColorMid,
  bgColorEnd,
}) => (
  <StyledOverlay
    className="absolute inset-0 overflow-hidden"
    style={{ mixBlendMode: 'multiply' }}
    aria-hidden="true"
    $hasHover={hasHover}
    $heroOverlayType={heroOverlayType}
    $heroOverlayAngleDesktop={heroOverlayAngleDesktop}
    $heroOverlayAngleMobile={heroOverlayAngleMobile}
    $heroOverlayWidth={heroOverlayWidth}
    $heroOverlayHeight={heroOverlayHeight}
    $bgColor={bgColor}
    $bgColorHover={bgColorHover}
    $bgColorStart={bgColorStart}
    $bgColorMid={bgColorMid}
    $bgColorEnd={bgColorEnd}
  />
);

Overlay.defaultProps = {
  hasHover: false,
};

Overlay.propTypes = {
  hasHover: PropTypes.bool,
  bgColor: PropTypes.string,
  bgColorHover: PropTypes.string,
  bgColorStart: PropTypes.string,
  bgColorMid: PropTypes.string,
  bgColorEnd: PropTypes.string,
};

export { Overlay };
